import { JsonPipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { Audience, ViewCategory } from '@ddt-web/config';
import { Country } from '@ddt-web/domain';
import { LocalStorageKey } from '@ddt-web/generic-utils';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { AudienceService } from '../../services/audience.service';

@UntilDestroy()
@Component({
	// eslint-disable-next-line @angular-eslint/component-selector
	selector: 'audience-mock-banner',
	templateUrl: './audience-mock-banner.component.html',
	styleUrls: ['./audience-mock-banner.component.scss']
})
export class AudienceMockBannerComponent implements OnInit {

	@Input() public defaultCountry: string = Country.default;

	private parsedUrl: URL;
	public countryMock: string;
	public listOfCountries: string[] = Object.keys(Country).map(key => Country[key]);
	public viewCategory: ViewCategory = null;
	public audience: Audience = null;

	constructor(private audienceService: AudienceService, private jsonPipe: JsonPipe) {
		this.audienceService.getViewCategory().pipe(untilDestroyed(this)).subscribe(view => {
			this.viewCategory = view;
		});
		this.audienceService.getAudience().pipe(untilDestroyed(this)).subscribe(audience => {
			this.audience = audience;
		});
	}

	public ngOnInit(): void {
		this.parsedUrl = new URL(window.location.href);
		this.countryMock = localStorage.getItem(LocalStorageKey.MockCountry);
	}

	public onCountrySelection(event: any): void {
		if (event.target.value === 'clear') {
			localStorage.removeItem(LocalStorageKey.MockCountry);
			this.parsedUrl.searchParams.delete('mockCountry');
			window.location.assign(this.parsedUrl.href);
		} else {
			localStorage.setItem(LocalStorageKey.MockCountry, event.target.value);
			this.parsedUrl.searchParams.set('mockCountry', event.target.value);
			window.location.assign(this.parsedUrl.href);
		}
	}
}
